import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Scan, Layers, ShoppingBag, User } from 'lucide-react';
import { cn } from '../../utils/cn';
import { motion } from 'framer-motion';

export const BottomNav = () => {
  const navItems = [
    { icon: Home, label: 'Home', path: '/' },
    { icon: Scan, label: 'Scan', path: '/scan', highlight: true },
    { icon: Layers, label: 'Collection', path: '/collection' },
    { icon: ShoppingBag, label: 'Market', path: '/market' },
    { icon: User, label: 'Profile', path: '/profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50" style={{ paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 12px)' }}>
      <div className="max-w-md mx-auto px-4 pb-2">
        <div className="h-16 rounded-2xl bg-black/80 backdrop-blur-xl border border-white/10 shadow-lg overflow-hidden relative">
          {/* Glossy overlay */}
          <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />

          <div className="flex justify-between items-center h-full px-2 relative z-10">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  cn(
                    "flex flex-col items-center justify-center w-full h-full space-y-1 transition-all duration-300 relative group",
                    isActive ? "text-white" : "text-slate-500 hover:text-slate-400"
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    {/* Active indicator dot */}
                    {isActive && (
                      <motion.div
                        layoutId="navIndicator"
                        className="absolute -top-1 w-1 h-1 rounded-full bg-electric-400 shadow-[0_0_8px_rgba(56,189,248,0.8)]"
                      />
                    )}

                    {/* Icon container */}
                    <div className={cn(
                      "relative p-1.5 rounded-xl transition-all duration-300",
                      isActive && item.highlight ? "bg-electric-500 text-white shadow-[0_0_15px_rgba(56,189,248,0.4)]" : "",
                      isActive && !item.highlight ? "bg-white/10" : ""
                    )}>
                      <item.icon className={cn(
                        "w-5 h-5 transition-transform duration-300",
                        isActive && "scale-105"
                      )} />
                    </div>

                    <span className={cn(
                      "text-[10px] font-medium tracking-wide transition-opacity",
                      isActive ? "opacity-100" : "opacity-0 group-hover:opacity-50"
                    )}>
                      {item.label}
                    </span>
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};
